import axios from '@axios'

export const fetchReportsList = async (params?: any): Promise<any> => {
  const res = await axios.get('/auth/reports', { params })
  return res
}

export const _ = null
